export default "__VITE_ASSET__GmD0nLaE__"